export default {
  jobs: [
    { 'value': 'shangwugoutong', 'label': '商务沟通' },
    { 'value': 'shichangdiaoyan', 'label': '市场调研' },
    { 'value': 'xuqiugoutong', 'label': '需求沟通' },
    { 'value': 'ziyuanshenqing', 'label': '资源申请' },
    { 'value': 'wendangshuchu', 'label': '文档输出' },
    { 'value': 'yuanxingsheji', 'label': '原型设计' },
    { 'value': 'xiangmuguanli', 'label': '项目管理' },
    { 'value': 'jiemiansheji', 'label': '界面设计' },
    { 'value': 'jiaohusheji', 'label': '交互设计' },
    { 'value': 'ruanjianceshi', 'label': '软件测试' },
    { 'value': 'zhiliangkongzhi', 'label': '质量控制' },
    { 'value': 'jiagousheji', 'label': '架构设计' },
    { 'value': 'houduankaifa', 'label': '后端开发' },
    { 'value': 'qianduankaifa', 'label': '前端开发' },
    { 'value': 'xiaochengxukaifa', 'label': '小程序开发' },
    { 'value': 'anzhuokaifa', 'label': '安卓开发' },
    { 'value': 'pingguokaifa', 'label': '苹果开发' },
    { 'value': 'neibupeixun', 'label': '内部培训' },
    { 'value': 'kehupeixun', 'label': '客户培训' },
    { 'value': 'yunweibushu', 'label': '运维部署' },
    { 'value': 'shouhoufuwu', 'label': '售后服务' },
    { 'value': 'qita', 'label': '其他' }
  ]
};
